module.exports = __webpack_public_path__ + "img/bland.c1036e72.png";